import { render, staticRenderFns } from "./AssessmentResultsAdd.vue?vue&type=template&id=d121223e&scoped=true"
import script from "./AssessmentResultsAdd.vue?vue&type=script&lang=js"
export * from "./AssessmentResultsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d121223e",
  null
  
)

export default component.exports